module.exports = __webpack_public_path__ + "static/img/BranchCompany3.2193ab8e.png";